import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider } from './components/AuthProvider'
import { QuietModeProvider } from './components/QuietModeProvider'
import { ThemeProvider } from './components/ThemeProvider'
import { DopaWidgetProvider } from './components/DopaWidgetProvider'
import DopaWidget from './components/DopaWidget'
import { useDopaWidget } from './components/DopaWidgetProvider'
import Home from './pages/Home'
import Landing from './pages/Landing'
import Tools from './pages/Tools'
import Support from './pages/Support'
import About from './pages/About'
import Contact from './pages/Contact'
import Privacy from './pages/Privacy'
import Disclaimer from './pages/Disclaimer'
import Terms from './pages/Terms'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import BreathingSpace from './components/BreathingSpace'
import GratitudeJournal from './components/GratitudeJournal'
import JournalEntries from './components/JournalEntries'
import MoodCheckIn from './components/MoodCheckIn'
import RoutineBuilder from './components/RoutineBuilder'
import SupportBot from './components/SupportBot'
import Footer from './components/Footer'

// ScrollToTop component to ensure page scrolls to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

const AppContent = () => {
  const { isWidgetEnabled } = useDopaWidget()

  return (
    <div className="min-h-screen bg-neutral-25 dark:bg-sage-900 flex flex-col">
      <ScrollToTop />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Home />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/support" element={<Support />} />
          <Route path="/dopa-listens" element={<SupportBot />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/breathing" element={<BreathingSpace />} />
          <Route path="/journal" element={<GratitudeJournal />} />
          <Route path="/journal-entries" element={<JournalEntries />} />
          <Route path="/mood" element={<MoodCheckIn />} />
          <Route path="/routines" element={<RoutineBuilder />} />
        </Routes>
      </div>
      
      {/* Footer - Only show on info/legal pages */}
      <Footer />
      
      {/* Floating Dopa Widget */}
      <DopaWidget isEnabled={isWidgetEnabled} />
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <QuietModeProvider>
          <DopaWidgetProvider>
            <AppContent />
          </DopaWidgetProvider>
        </QuietModeProvider>
      </ThemeProvider>
    </AuthProvider>
  )
}

export default App